<template>
  <div class="right flexauto page-wrapper">
    <!-- <search-list :projectList="projectList" @findData="findData"  @clear="clearValue"></search-list> -->
    <search-group title="" :multipleLines="false" :inline="true" :span="24" :btnOffset="18" :btnSpan="6" @search="findData" @clear="clearValue">

      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="项目名称" v-model="searchData.projectFid">
            <!-- <Option value="">请选择</Option> -->
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" v-model="searchData.stockNum"  @keyup.enter.native="findData" placeholder="房间号"/>
        </Col>
        <Col span="5">
          <Select placeholder="设备名称" v-model="searchData.deviceType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in searchDeviceName" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="工单状态" v-model="searchData.status">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in orderStatus" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" v-model="searchData.workOrderNo" placeholder="工单号"/>
        </Col>
      </Row>
    </search-group>
    <Button v-p="{api:'increase/orderForStock'}"  type="primary" class="mb16" @click="addDevice">添加云钉智能设备</Button>
    <Button v-p="{api:'increase/orderForSmartHome'}"  type="primary" class="mb16" @click="addFurniture">添加自如智能家居</Button>

    <table-list
      title="" :columns="columns" :data="dataTable"
      :loading="loading"
      :total="total"
      :current="current"
      @change-page="changePage">
    </table-list>
    <re-add
    :n="addN"
    :fid="fid"
    @refresh="getOrderList()"
    ></re-add>
    <add-furniture :n="furnitureKey" :projectList="projectList" @refresh="getOrderList()"></add-furniture>
    <add-device :n="deviceKey" :projectList="projectList" @refresh="getOrderList()"></add-device>
  </div>
</template>

<script>
  // import SearchGroup from 'components/SearchGroup/index';

  // import TableList from "components/TableList/index";
  // import SearchList from './components/SearchList'
  import ReAdd from './components/ReAdd'
  import AddFurniture from './components/AddFurniture'
  import AddDevice from './components/AddDevice'
  import {deepClone,formatDateTime} from "@/utils/format";
  import {buildInfo} from "api/house";
  import { getOrderList, updateIntellectStatus ,getDeviceType} from "api/smartWorkOrder"

  export default {
    name: "workbench",
    components: {
      // SearchList,
      AddFurniture,
      // SearchGroup,
      AddDevice,
      // TableList,
      ReAdd
    },
    data() {
      return {
        fid:'',
        searchDeviceName:[],
        orderStatus:[],
        deviceType:[],
        addN:0,
        projectList: [],
        searchData: {
          "projectFid": "",
          "stockNum": '',
          limit: 10,
          page: 1,
          deviceType:'',
          status:'',
          workOrderNo:'',
        },
        current: 1,
        deviceKey:0,
        furnitureKey:0,
        loading: false,
        dataTable: [],
        total: 0,
        columns:[
          {
            type:'index',
            width:60,
          },
          {title:' '},
          {
            title:'项目名称',
            key:'projectName',
            align:'center',
            width:180,
          },
          {title:' '},
          {
            title:'房间号' ,
            key:'stockNum',
            align:'center',
            width:180,
            render: (h, params) => {
              if (params.row['stockNum'] && params.row['stockNum'].length > 20) {
                return h('Tooltip', {
                  props: {
                    placement: "top"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row['stockNum']),
                  h('span', {}, params.row['stockNum'].slice(0, 20) + '...')
                ])

              }
              else {
                return h('span', {}, params.row['stockNum'])
              }
            }
          },
          {title:' '},
          // {
          //   title:'设备' ,
          //   key:'deviceType',
          //   align:'center',
          //   width:200,
          //   render: (h, params) => {
          //     if (params.row['deviceType'] && params.row['deviceType'].length > 20) {
          //       return h('Tooltip', {
          //         props: {
          //           placement: "top"
          //         }
          //       }, [
          //         h('div', {
          //           style: {
          //             whiteSpace: 'normal'
          //           },
          //           slot: 'content',
          //         }, params.row['deviceType']),
          //         h('span', {}, params.row['deviceType'].slice(0, 20) + '...')
          //       ])

          //     }
          //     else {
          //       return h('span', {}, params.row['deviceType'])
          //     }
          //   }
          // },
          // {title:' '},
          {
            title:'设备位置' ,
            key:'areaTypeCode',
            align:'center',
            width:120,
          },
          {title:' '},
          {
            title:'设备名称' ,
            key:'deviceType',
            align:'center',
            width:120,
          },
          {title:' '},
          {
            title:'工单编号' ,
            key:'workOrderNo',
            align:'center',
            width:200,
          },
          {title:' '},
          {
            title:'下单时间' ,
            key:'createTime',
            align:'center',
            width:200,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['createTime'],true))
            }
          },
          {title:' '},
          {
            title:'工单状态' ,
            key:'statusName',
            align:'center',
            width:200,
          },
          {title:' '},
          {
            title:'操作',
            key:'actions',
            align:'center',
            width:130,
            fixed:'right',
            render:(h,params)=>{
              return[
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'increase/updateIntellectStatus'
                      }
                    }
                  ],
                  on: {
                    click:()=>{
                      this.fid = params.row['fid']
                      this.addN++;
                    }
                  },
                  style:{
                    display:params.row['status']===0?'none':'',
                  }
                }, '重新添加')
              ]
              // let actions = [];
              // let data = params.row;
              // if (data.status === 0) {
              //   actions.push(enable)
              // }
              // return h('div',{}, actions)
            }
          },
        ],
      }
    },
    methods: {
      getDeviceInfo(){
        getDeviceType()
        .then(res=>{
          this.searchDeviceName = res.data.searchDeviceName;
          this.orderStatus = res.data.orderStatus;
        })
      },
      findData() {
        this.current = 1;
        this.getOrderList()
      },
      addDevice(){
        this.deviceKey++
      },
      addFurniture(){
        this.furnitureKey++
      },
      changePage(n){
        this.current = n;
        this.searchData.page = n;
        this.getOrderList()
      },
      getOrderList(){
        /*let params={
          ...this.searchData,
        };*/
        getOrderList(this.searchData).then(res=>{
          if(!res.data){
            return
          }
          this.dataTable=res.data.rows;
          this.total=res.data.total;
        }).catch(error=>{})
      },
      clearValue() {
        this.searchData= {
          "projectFid": "",
          "stockNum": '',
          limit: 10,
          page: 1,
          deviceType:'',
          status:'',
          workOrderNo:'',
        }
      },
      enableDevice(fid){
        this.$Modal.confirm({
          content:'<p>确认启用此设备？</p>',
          onOk:()=>{
            updateIntellectStatus({'fid': fid}).then(res => {
              this.loading = false
              this.$Message.success('智能设备启用成功')
              this.getOrderList()
            }).catch( res => {
              this.loading=false
            })
          }
        })
      },
    },
    created() {

      this.getDeviceInfo();

      buildInfo().then(res => {
          res.data && ( this.projectList = res.data)
          if(this.projectList && this.projectList.length>0){
            this.searchData.projectFid=this.projectList[0].value
            this.findData()
        }

      }).catch(error => {
      })
      // this.getDeviceInfo();
    }
  }
</script>

<style scoped>
  .right{
    overflow: auto;

  }
  .search-wrapper{
    padding:0!important;
  }
</style>
